export enum CampaignErrorField {
  name = 'name',
  enrollContacts = 'enrollContacts',
  messageStep = 'messageStep',
}
